import {
    ChangeDetectorRef,
    Component,
    forwardRef,
    ChangeDetectionStrategy,
    inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NameValue } from '../../models/name-value';
import { TRAVEL_STATUSES } from '../../constants/travel-statuses';

@Component({
    selector: 'app-travel-statuses-filter',
    templateUrl: './travel-statuses-filter.component.html',
    styleUrls: ['./travel-statuses-filter.component.scss'],
    imports: [LabelModule, DropDownsModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TravelStatusesFilterComponent),
            multi: true,
        },
    ],
})
export class TravelStatusesFilterComponent implements ControlValueAccessor {
    private cdr = inject(ChangeDetectorRef);

    public readonly travelStatuses: NameValue[] = TRAVEL_STATUSES;

    public isDisabled: boolean = false;
    public value: string[] = [];

    private onChange: (value: string[]) => void = () => {};
    private onTouched: () => void = () => {};

    writeValue(value: string[]): void {
        this.value = value ?? [];
        this.cdr.markForCheck();
    }

    registerOnChange(fn: (value: string[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    handleValueChange(value: string[]): void {
        this.value = value;
        this.onChange(value);
    }

    handleBlur(): void {
        this.onTouched();
    }
}
